import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

const LastingImpression = () => {
  useEffect(() => {
    const tl = gsap.timeline();
    tl.to(".hero_txt", {
      y: 0,
      stagger: {
        amount: 0.8,
      },
    });

    const tlt2 = gsap.timeline({
      scrollTrigger: {
        trigger: ".second_hero_sec",
        start: "top 30%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });
    const tlt3 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextOne",
        start: "top 30%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt4 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextTwo",
        start: "top 30%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });
    const tlt5 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextThree",
        start: "top 30%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });
    const tlt6 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextFour",
        start: "top 30%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });
    const tlt7 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextFive",
        start: "top 30%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });
    const tlt8 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextSix",
        start: "top 30%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });
    const tlt9 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextSeven",
        start: "top 30%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    tlt2.to(".second_hero_sec", {
      opacity: 1,
      y: "-20rem",
    });
    tlt3.to(".contentTextOne", {
      opacity: 1,
      y: "-20rem",
    });
    tlt4.to(".contentTextTwo", {
      opacity: 1,
      y: "-20rem",
    });
    tlt5.to(".contentTextThree", {
      opacity: 1,
      y: "-20rem",
    });
    tlt6.to(".contentTextFour", {
      opacity: 1,
      y: "-20rem",
    });
    tlt7.to(".contentTextFive", {
      opacity: 1,
      y: "-20rem",
    });
    tlt8.to(".contentTextSex", {
      opacity: 1,
      y: "-20rem",
    });
    tlt9.to(".contentTextSeven", {
      opacity: 1,
      y: "-20rem",
    });
  }, []);
  return (
    <>
      {/* Banner Component Start Here */}
      <main className="heroMain">
        <section
          className="second_hero_sec fullpageScroll"
          style={{ height: "160vh", opacity: 0 }}
        >
          <div className="container">
            <h2 className="subtitle" id="test">
              <span className="hero_txt">CrispBrains</span>: Leaving a Lasting
              Impression, Driving Sustainable Growth
            </h2>
          </div>
        </section>

        <section
          className="contentTextOne for_css_text fullpageScroll"
          style={{ height: "100vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              We believe in the power of digital marketing to go beyond just
              generating leads. We're about building meaningful connections with
              your customers, creating a lasting positive impression, and
              fueling your sustainable growth.
            </h2>
          </div>
        </section>

        <section
          className="contentTextTwo for_css_text fullpageScroll"
          style={{ height: "100vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              Our 360° approach ensures you don't just get more customers, but
              you also keep them coming back for more. We'll help you:
            </h2>
          </div>
        </section>

        <section
          className="contentTextThree for_css_text fullpageScroll"
          style={{ height: "100vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              • Build a Reputable Digital Community: Foster trust and loyalty
              through engaging social media, interactive campaigns, and content
              that resonates.
            </h2>
          </div>
        </section>

        <section
          className="contentTextFour for_css_text fullpageScroll"
          style={{ height: "100vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              • Optimize the Customer Journey: From discovery to purchase, we
              create a seamless experience that keeps your customers happy and
              coming back for more.
            </h2>
          </div>
        </section>

        <section
          className="contentTextFive for_css_text fullpageScroll"
          style={{ height: "100vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              • Deliver Measurable Results: We track every campaign's
              performance, providing you with clear data and actionable insights
              to prove our impact.
            </h2>
          </div>
        </section>

        <section
          className="contentTextSix for_css_text fullpageScroll"
          style={{ height: "100vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              Ready to leave a lasting impression and achieve sustainable
              growth?
            </h2>
          </div>
        </section>

        {/* <section
          className="contentTextSeven for_css_text fullpageScroll"
          style={{ height: "100vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              Contact <span className="hero_txt">CrispBrains</span> today and
              let's unlock your brand's full potential together!
            </h2>
          </div>
        </section> */}
      </main>
      {/* Banner Component End Here */}
    </>
  );
};

export default LastingImpression;
